/* eslint-disable no-unexpected-multiline */

import React, { useState, useEffect } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import {
  Card,
  Row,
  Span,
  CollapseColumn,
  Button,
  Image,
  Col,
  Grid,
  Text,
  SimpleCollapse,
  PageFooter
} from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { PdfIcon, ExcelIcon } from 'components/Svg'
import { useToggle, useLoading, useReportPrint, useModal } from 'hooks'
import useApp from 'hooks/useApp'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import {
  GrupoItenHht,
  IRelatorioHht,
  ReportsEffectivesNGTServices,
  TotalGeralHht
} from 'services/NGT/ReportsEffectives'
import { COLORS, SPACING, FONTS, TYPOGRAPHY } from 'utils'

import { IRequestBody } from '../../ReportsEffectives'
import TableSalaryReportContract from './TableSalaryReportContract'
import TableSalaryReportSupplier from './TableSalaryReportSupplier'
import FormatarNumeros from '../../../../../../utils/formatNumbers'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Box, LinearProgress } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

export interface GroupCardRelatorioHht {
  grupos: GroupCardRelatorioHhtList[]
  totalGeral: TotalGeralHht
}

export interface GroupCardRelatorioHhtList {
  isOpen: boolean
  chaveGrupo: string
  grupoItens: GrupoItenHht[]
}

const DEFAULT_RELATORIO_HHT: GroupCardRelatorioHht = {
  grupos: [],
  totalGeral: {
    cdContrato: '',
    dataCompFim: '',
    dataCompIni: '',
    de: '',
    dir: '',
    efetivoTotalAnterior: 0,
    folhaPgtoTotal: 0,
    folhaPgtoTotalAnterior: 0,
    ger: '',
    gg: '',
    grupo: '',
    justifQtdHe: '',
    justificativaNumeroEfetivos: '',
    justificativaVlrContratada: '',
    mesAno: '',
    mesAnoAnterior: '',
    nmFornecedor: '',
    percentHe: 0,
    percentHeAnterior: 0,
    percentHeHht: 0,
    percentHeHhtAnterior: 0,
    qtTotalEfetivoComDemitido: 0,
    qtTotalEfetivoSemDemitido: 0,
    qtdHe: 0,
    qtdHeAnterior: 0,
    qtdHht: 0,
    qtdHhtAnterior: 0,
    salBaseTotal: 0,
    salBaseTotalAnterior: 0
  }
}

interface location {
  request_body: any
  name: any
  hash: string
  pathname: string
  search: string
  state: {
    name: string
    request_body: IRequestBody
  }
}

const DEFAULT_ERROR = 'Não foi possível encontrar o relatório com esses termos'
const DEFAULT_SCROLL_LOAD_ITEMS = 20

const HHTandSalaryReportsReport: React.FC = () => {
  const { setLoading } = useLoading()
  const {
    handlePrintHHTSalarioPorContrato,
    handlePrintHHTSalarioPorFornecedor
  } = useReportPrint()
  const [isError, toggleErrorModal] = useToggle()
  const history = useHistory()
  const location = useLocation<location>()

  const { showModal } = useModal()

  const [tableDataResponse, setTableDataResponse] =
    useState<GroupCardRelatorioHht>(DEFAULT_RELATORIO_HHT)
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    DEFAULT_ERROR
  )
  const [dataCompetenciaIni, setDataCompetenciaIni] = useState<string>('')
  const [dataCompetenciaFim, setDataCompetenciaFim] = useState<string>('')
  const [excelProp, setExcelProp] = useState()
  const [slicedList, setSlicedList] = useState<GroupCardRelatorioHhtList[]>([])

  const dataInicio = location.state?.request_body.competenciaDataIni
    ? moment(location.state?.request_body.competenciaDataIni).format('MM/YYYY')
    : null
  const dataFim = location.state?.request_body.competenciaDataFim
    ? moment(location.state?.request_body.competenciaDataFim).format('MM/YYYY')
    : null

  const { setTitlePage } = useApp()
  const isContractHht = () => location?.state.name === 'ContratoHHT'

  // When component unmounts the function inside useeffect is called
  useEffect(() => {
    if (isContractHht()) {
      setTitlePage('Relatório de HHT x Salário por Contrato')
    } else {
      setTitlePage('Relatório de HHT x Salário por Fornecedor')
    }

    return () => {
      setTitlePage(null)
      setLoading('idle')
    }
  }, [])

  const handleView = () => {
    setLoading('loading')
    ReportsEffectivesNGTServices()
    [location.state.name](location.state.request_body)
      .then((response) => {
        const responseData: IRelatorioHht = response?.data?.entity

        if (!responseData || !response?.data?.sucesso) {
          if (response?.data?.mensagem) {
            setErrorMessage(response?.data?.mensagem)
          }

          toggleErrorModal()
          setLoading('idle')
          return
        }

        setLoading('idle')
        setExcelProp(response.data)
        const newGroup = responseData.grupos?.map((element) => ({
          ...element,
          isOpen: false
        }))
        setSlicedList(newGroup.slice(0, DEFAULT_SCROLL_LOAD_ITEMS))

        setDataCompetenciaIni(
          responseData.grupos[0].grupoItens[0].dataCompIni?.toString()
        )
        setDataCompetenciaFim(
          responseData.grupos[0].grupoItens[0].dataCompFim?.toString()
        )

        setTableDataResponse({
          ...responseData,
          grupos: newGroup
        })
      })
      .catch((err) => {
        setLoading('idle')
        // toggleErrorModal()
        showModal({
          hideButtonCancel: true,
          message: err.mensagem || err.message || 'Falha ao obter relatório.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleExcel = () => {
    setLoading('loading')
    let propToExcel = excelProp
    if (excelProp) propToExcel = formatarObjetoExcel(propToExcel)

    ReportsEffectivesNGTServices()
      .RelatorioExcel(propToExcel, location.state.name)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = 'RELATORIO-DE-RELATORIOS-DE-HHT-SALARIO.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  useEffect(() => {
    handleView()
  }, [])

  const handleCollpasePdf = (index) => {
    const cpy = JSON.parse(JSON.stringify(tableDataResponse))

    cpy.grupos[index].isOpen = !cpy.grupos[index].isOpen
    setTableDataResponse(cpy)
    setSlicedList((prev) => tableDataResponse.grupos.slice(0, prev.length))
  }

  const nextPagination = (grupos: GroupCardRelatorioHhtList[]) => {
    setTimeout(() => {
      const currentLength = slicedList.length
      const newItems = grupos.slice(
        currentLength,
        currentLength + DEFAULT_SCROLL_LOAD_ITEMS
      )
      setSlicedList((prevState) => prevState.concat([...newItems]))
    }, 1000)
  }

  const handlePrintContractReport = () => {
    setLoading('loading')
    setTimeout(() => {
      handlePrintHHTSalarioPorContrato({
        data: {
          content: tableDataResponse?.grupos.map((contract) => ({
            body: contract?.grupoItens
              .map((column) => ({
                'HE%': column.percentHe,
                JustificativaNºEfetivos:
                  column.justificativaNumeroEfetivos || '---',
                JustificativaVlrContratada:
                  column.justificativaVlrContratada || '---',
                contrato: column.cdContrato,
                folhaPgtoTotal: column.folhaPgtoTotal,
                'justificativaHE%': column.justifQtdHe || '---',
                mesAno: column.mesAno,
                qtTotalEfetivoSemDemitido: column.qtTotalEfetivoSemDemitido,
                qtdHE: column.qtdHe,
                qtdHHT: column.qtdHht,
                salBaseTotal: column.salBaseTotal
              }))
              .slice(0, -1),
            cdContrato: contract?.grupoItens[0]?.cdContrato,
            de: contract?.grupoItens[0]?.de || '---',
            dir: contract?.grupoItens[0]?.dir || '---',
            footer: (() => {
              const subTotal = contract.grupoItens.find(
                (contract) => contract.grupo === 'SubTotal'
              )

              return {
                mesAno: {
                  '%HHTxHE': formatarNumero(
                    subTotal.percentHeHht
                  ) as unknown as number,
                  mesAno: subTotal.mesAno,
                  totalEfetivo: formatarNumero(
                    subTotal.qtTotalEfetivoSemDemitido
                  ) as unknown as number,
                  totalFolha: subTotal.folhaPgtoTotal,
                  totalHE: formatarNumero(subTotal.qtdHe) as unknown as number,
                  totalHHT: formatarNumero(subTotal.qtdHht) as unknown as number,
                  totalSalarioBase: subTotal.salBaseTotal
                },
                mesAnoAnterior: {
                  '%HHTxHE': formatarNumero(
                    subTotal.percentHeHhtAnterior
                  ) as unknown as number,
                  mesAno: subTotal.mesAnoAnterior,
                  totalEfetivo: formatarNumero(
                    subTotal.efetivoTotalAnterior
                  ) as unknown as number,
                  totalFolha: subTotal.folhaPgtoTotalAnterior,
                  totalHE: formatarNumero(
                    subTotal.qtdHeAnterior
                  ) as unknown as number,
                  totalHHT: formatarNumero(
                    subTotal.qtdHhtAnterior
                  ) as unknown as number,
                  totalSalarioBase: subTotal.salBaseTotalAnterior
                }
              }
            })(),
            ger: contract?.grupoItens[0]?.ger || '---',
            gg: contract?.grupoItens[0]?.gg || '---',
            nmFornecedor: contract?.grupoItens[0]?.nmFornecedor
          })),
          mesAno: {
            '%HHTxHE': formatarNumero(
              tableDataResponse.totalGeral.percentHeHht
            ) as unknown as number,
            mesAno: tableDataResponse.totalGeral.mesAno,
            totalEfetivo: formatarNumero(
              tableDataResponse.totalGeral.qtTotalEfetivoSemDemitido
            ) as unknown as number,
            totalFolha: tableDataResponse.totalGeral.folhaPgtoTotal,
            totalHE: formatarNumero(
              tableDataResponse.totalGeral.qtdHe
            ) as unknown as number,
            totalHHT: formatarNumero(
              tableDataResponse.totalGeral.qtdHht
            ) as unknown as number,
            totalSalarioBase: tableDataResponse.totalGeral.salBaseTotal
          },
          mesAnoAnterior: {
            '%HHTxHE': formatarNumero(
              tableDataResponse.totalGeral.percentHeHhtAnterior
            ) as unknown as number,
            mesAno: tableDataResponse.totalGeral.mesAnoAnterior,
            totalEfetivo: formatarNumero(
              tableDataResponse.totalGeral.efetivoTotalAnterior
            ) as unknown as number,
            totalFolha: tableDataResponse.totalGeral.folhaPgtoTotalAnterior,
            totalHE: formatarNumero(
              tableDataResponse.totalGeral.qtdHeAnterior
            ) as unknown as number,
            totalHHT: formatarNumero(
              tableDataResponse.totalGeral.qtdHhtAnterior
            ) as unknown as number,
            totalSalarioBase: tableDataResponse.totalGeral.salBaseTotalAnterior
          },
          mesFinal: dataFim || dataCompetenciaFim || '---',
          mesInicial: dataInicio || dataCompetenciaIni || '---',
          title: 'RELATÓRIO DE HHT X SALÁRIO POR CONTRATO'
        },
        filename: `relatório-de-hht-salario-por-contrato-${moment().format(
          'DD-MM-YYYY'
        )}`
      })
    }, 100)
    setLoading('idle')
  }

  const handlePrintSupplierReport = () => {
    handlePrintHHTSalarioPorFornecedor({
      data: {
        content: tableDataResponse?.grupos.map((contract) => ({
          body: contract?.grupoItens
            .map((column) => ({
              'HE%': column.percentHe,
              JustificativaNºEfetivos:
                column.justificativaNumeroEfetivos || '---',
              JustificativaVlrContratada:
                column.justificativaVlrContratada || '---',
              cdContrato: column.cdContrato,
              de: column.de || '---',
              dir: column.dir || '---',
              folhaPgtoTotal: column.folhaPgtoTotal,
              ger: column.ger || '---',
              gg: column.gg || '---',
              'justificativaHE%': column.justifQtdHe || '---',
              qtTotalEfetivoComDemitido: column.qtTotalEfetivoComDemitido,
              qtTotalEfetivoSemDemitido: column.qtTotalEfetivoSemDemitido,
              qtdHE: column.qtdHe,
              qtdHHT: column.qtdHht,
              salBaseTotal: column.salBaseTotal
            }))
            .slice(0, -1),
          footer: (() => {
            const subTotal = contract.grupoItens.find(
              (contract) => contract.grupo === 'SubTotal'
            )

            return {
              mesAno: {
                '%HHTxHE': formatarNumero(
                  subTotal.percentHeHht
                ) as unknown as number,
                mesAno: subTotal.mesAno,
                totalEfetivo: formatarNumero(
                  subTotal.qtTotalEfetivoSemDemitido
                ) as unknown as number,
                totalFolha: subTotal.folhaPgtoTotal,
                totalHE: formatarNumero(subTotal.qtdHe) as unknown as number,
                totalHHT: formatarNumero(subTotal.qtdHht) as unknown as number,
                totalSalarioBase: subTotal.salBaseTotal
              },
              mesAnoAnterior: {
                '%HHTxHE': formatarNumero(
                  subTotal.percentHeHhtAnterior
                ) as unknown as number,
                mesAno: subTotal.mesAnoAnterior,
                totalEfetivo: formatarNumero(
                  subTotal.efetivoTotalAnterior
                ) as unknown as number,
                totalFolha: subTotal.folhaPgtoTotalAnterior,
                totalHE: formatarNumero(
                  subTotal.qtdHeAnterior
                ) as unknown as number,
                totalHHT: formatarNumero(
                  subTotal.qtdHhtAnterior
                ) as unknown as number,
                totalSalarioBase: subTotal.salBaseTotalAnterior
              }
            }
          })(),
          nmFornecedor: contract?.grupoItens[0].nmFornecedor
        })),
        mesAno: {
          '%HHTxHE': formatarNumero(
            tableDataResponse.totalGeral.percentHeHht
          ) as unknown as number,
          mesAno: tableDataResponse.totalGeral.mesAno,
          totalEfetivo: formatarNumero(
            tableDataResponse.totalGeral.qtTotalEfetivoSemDemitido
          ) as unknown as number,
          totalFolha: tableDataResponse.totalGeral.folhaPgtoTotal,
          totalHE: formatarNumero(
            tableDataResponse.totalGeral.qtdHe
          ) as unknown as number,
          totalHHT: formatarNumero(
            tableDataResponse.totalGeral.qtdHht
          ) as unknown as number,
          totalSalarioBase: tableDataResponse.totalGeral.salBaseTotal
        },
        mesAnoAnterior: {
          '%HHTxHE': formatarNumero(
            tableDataResponse.totalGeral.percentHeHhtAnterior
          ) as unknown as number,
          mesAno: tableDataResponse.totalGeral.mesAnoAnterior,
          totalEfetivo: formatarNumero(
            tableDataResponse.totalGeral.efetivoTotalAnterior
          ) as unknown as number,
          totalFolha: tableDataResponse.totalGeral.folhaPgtoTotalAnterior,
          totalHE: formatarNumero(
            tableDataResponse.totalGeral.qtdHeAnterior
          ) as unknown as number,
          totalHHT: formatarNumero(
            tableDataResponse.totalGeral.qtdHhtAnterior
          ) as unknown as number,
          totalSalarioBase: tableDataResponse.totalGeral.salBaseTotalAnterior
        },
        mesFinal: dataFim || dataCompetenciaFim || '---',
        mesInicial: dataInicio || dataCompetenciaIni || '---',
        title: 'RELATÓRIO DE HHT X SALÁRIO POR FORNECEDOR'
      },
      filename: `relatório-de-hht-salario-por-fornecedor-${moment().format(
        'DD-MM-YYYY'
      )}`
    })
  }

  const handlePrintReport = () => {
    isContractHht() ? handlePrintContractReport() : handlePrintSupplierReport()
  }

  const HeaderSupplierTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
      </Row>
      <Span
        text={
          isContractHht()
            ? 'RELATÓRIO DE HHT X SALÁRIO POR CONTRATO'
            : 'RELATÓRIO DE HHT X SALÁRIO POR FORNECEDOR'
        }
        color={COLORS.blueFonts}
        fontSize="24px"
        fontWeight={FONTS.bold}
        textTransform="uppercase"
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      />
    </Card>
  )

  return (
    <>
      <Card
        marginTop={SPACING.spacing20}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
        id="divToPrint"
      >
        <HeaderSupplierTitle />
        <Card backgroundColor={COLORS.primary} padding="8px 0">
          <Row alignItems="center" justifyContent="center">
            <Span
              text={`HHT X SALÁRIO - ${dataInicio || dataCompetenciaIni} - ${dataFim || dataCompetenciaFim
                }`}
              marginRight={SPACING.spacing50}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
          </Row>
        </Card>
        <Row justifyContent="flex-end" marginTop="5px">
          <Button
            text="Voltar"
            startIcon={<ArrowBack />}
            marginRight='1rem'
            //variantButton="outlined"
            backgroundColor={COLORS.white} // Fundo branco
            textColor={COLORS.blueFonts} // Texto azul escuro
            borderColor={COLORS.blueFonts} // Borda azul claro
            boxShadow={`0 2px 4px ${COLORS.gray}`}
            style={{ textAlign: 'center' }}
            onClick={() => {
              setTitlePage(null)
              history.push({
                pathname: '/ngt/relatorios-efetivos'
              })
            }}
          />
          <a>
            <ExcelIcon onClick={handleExcel} />
          </a>
          <PdfIcon onClick={() => handlePrintReport()} />
        </Row>
        <InfiniteScroll
          dataLength={slicedList.length}
          next={() => nextPagination(tableDataResponse.grupos)}
          hasMore={tableDataResponse.grupos.length > slicedList.length}
          loader={
            <Box sx={{ width: '100%', marginBottom: '20px' }}>
              <LinearProgress />
            </Box>
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Final da listagem</b>
            </p>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
          }
        >
          {slicedList &&
            slicedList?.map((grupo, index) => {
              return isContractHht() ? (
                <CollapseColumn
                  index={index}
                  key={index.toString()}
                  inicio="01/01/2016"
                  fim="02/02/2017"
                  nmFornecedor={grupo?.grupoItens[0].nmFornecedor}
                  nuContrato={grupo?.grupoItens[0]?.cdContrato}
                  nmDiretoriaExecutiva={grupo?.grupoItens[0].de}
                  nmDiretoria={grupo?.grupoItens[0].dir}
                  nmGerenciaGeral={grupo?.grupoItens[0].gg}
                  nmGerencia={grupo?.grupoItens[0].ger}
                  isOpen={true}
                  toggleExpand={handleCollpasePdf}
                >
                  <TableSalaryReportContract tableData={grupo?.grupoItens} />
                </CollapseColumn>
              ) : (
                <SimpleCollapse
                  data-html2canvas-ignore="true"
                  key={grupo.chaveGrupo}
                  title={`Fornecedor: ${grupo.chaveGrupo}`}
                  textColor={COLORS.black}
                >
                  <TableSalaryReportSupplier tableData={grupo?.grupoItens} />
                </SimpleCollapse>
              )
            })}
        </InfiniteScroll>

        <Box margin="0">
          <PageFooter bottomPosition="66px">
            <Grid
              gridCols="1fr 1fr"
              gridGap="0.4rem"
              margin="0"
              padding="0 0 1rem 0"
            >
              <Grid gridCols="1fr" gridGap="0.4rem" margin="1rem 0 0 0">
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="MÊS ANO ANTERIOR: "
                  />
                  <Span
                    color={COLORS.blueFonts}
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text={tableDataResponse?.totalGeral?.mesAnoAnterior}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Salário Base: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={tableDataResponse?.totalGeral?.salBaseTotalAnterior
                      ?.toLocaleString('pt-BR', {
                        currency: 'BRL',
                        style: 'currency'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Folha: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={tableDataResponse?.totalGeral?.folhaPgtoTotalAnterior
                      ?.toLocaleString('pt-BR', {
                        currency: 'BRL',
                        style: 'currency'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total HHT: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.qtdHhtAnterior
                    )}
                  />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total HE: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.qtdHeAnterior
                    )}
                  />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total Efetivo: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.efetivoTotalAnterior
                    )}
                  />
                </Text>
                <Text></Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="% HHT x HE:"
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.percentHeHhtAnterior
                    )}
                  />
                </Text>
              </Grid>

              <Grid gridCols="1fr" gridGap="0.4rem" margin="1rem 0 0 0">
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="MÊS/ANO: "
                  />
                  <Span
                    color={COLORS.blueFonts}
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text={tableDataResponse?.totalGeral?.mesAno}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Salário Base: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={tableDataResponse?.totalGeral?.salBaseTotal
                      .toLocaleString('pt-BR', {
                        currency: 'BRL',
                        style: 'currency'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Folha: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={tableDataResponse?.totalGeral?.folhaPgtoTotal
                      .toLocaleString('pt-BR', {
                        currency: 'BRL',
                        style: 'currency'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total HHT: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(tableDataResponse?.totalGeral?.qtdHht)}
                  />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total HE: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(tableDataResponse?.totalGeral?.qtdHe)}
                  />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total Efetivo: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.qtTotalEfetivoSemDemitido
                    )}
                  />
                </Text>
                <Text></Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="% HHT x HE:"
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={formatarNumero(
                      tableDataResponse?.totalGeral?.percentHeHht
                    )}
                  />
                </Text>
              </Grid>
            </Grid>
          </PageFooter>
        </Box>
      </Card>
      <SuccessModal
        message={errorMessage}
        open={isError}
        type={errorMessage === DEFAULT_ERROR ? 'error' : 'alert'}
        handleConfirm={() => {
          toggleErrorModal()
          history.push({
            pathname: '/ngt/relatorios-efetivos'
          })
        }}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero)
}

function formatarObjetoExcel(excelProp) {
  // Fazendo uma cópia profunda do objeto excelProp
  // Pois se não efetuar este processo o Javascript cria um objeto em cima de uma referencia do anterior
  // Deste modo criando bugs e alterando todos objetos com referencia no excelProp.
  const ReformattedExcelProp = JSON.parse(JSON.stringify(excelProp))

  try {
    ReformattedExcelProp.entity.grupos.forEach((group) => {
      group.grupoItens.forEach((item) => {
        // Convertendo o valor para número e formatando para "0.00"
        item.percentHe = parseFloat(
          item.percentHe.replace('.', '').replace(',', '.')
        )
        item.qtdHht = parseFloat(item.qtdHht.replace('.', '').replace(',', '.'))
        item.qtdHe = parseFloat(item.qtdHe.replace('.', '').replace(',', '.'))
        item.percentHeHht = parseFloat(
          item.percentHeHht.replace('.', '').replace(',', '.')
        )
        item.qtTotalEfetivoSemDemitido = item.qtTotalEfetivoSemDemitido
          ? parseFloat(
            item.qtTotalEfetivoSemDemitido.replace('.', '').replace(',', '.')
          )
          : 0
        item.efetivoTotalAnterior = item.efetivoTotalAnterior
          ? parseFloat(
            item.efetivoTotalAnterior.replace('.', '').replace(',', '.')
          )
          : 0

        item.qtdHeAnterior = parseFloat(
          item.qtdHeAnterior.replace('.', '').replace(',', '.')
        )
        item.qtdHhtAnterior = parseFloat(
          item.qtdHhtAnterior.replace('.', '').replace(',', '.')
        )
        item.percentHeAnterior = parseFloat(
          item.percentHeAnterior.replace('.', '').replace(',', '.')
        )
        item.percentHeHhtAnterior = parseFloat(
          item.percentHeHhtAnterior.replace('.', '').replace(',', '.')
        )
      })
    })

    return ReformattedExcelProp
  } catch (error) {
    console.error('🚀 ~ formatarObjetoExcel ~ error:', error)
    return ReformattedExcelProp
  }
}

export default HHTandSalaryReportsReport
